export default function () {

    let headerContainer = document.querySelector('.header__container');
    let headerHomeMenu = document.querySelector('.header__home-menu');

    function setPaddingLeft() {
        let paddingLeftValue = window.getComputedStyle(headerContainer).paddingLeft;
        paddingLeftValue = paddingLeftValue.replace('px', '');
        headerHomeMenu.style.paddingLeft = (Number(paddingLeftValue)) + 'px';
    }

    window.addEventListener('load', setPaddingLeft);
    window.addEventListener('resize', setPaddingLeft);
   function handleHeaderHeight() {
       const header = document.querySelector('.header');
       const nav = document.querySelector('.header__home-menu');
       const menu = document.querySelector('.header__home-nav');
       let headerHeight = header.offsetHeight;
       let navHeight = nav.offsetHeight;
       let menuPosition = headerHeight - 20;
       let pagePadding = headerHeight;

       const about = document.querySelector('.about');
       const projects = document.querySelector('.projects');
       const singleProjects = document.querySelector('.single-project');

       // if (singleProjects) {
       //     singleProjects.style.paddingTop = headerHeight + 'px';
       // }
       //
       // if (window.innerWidth < 992) {
       //     if (about) {
       //         about.style.paddingTop = pagePadding + 'px';
       //     }
       // } else if (window.innerWidth > 992) {
       //     if (about) {
       //         about.style.paddingTop = headerHeight + 'px';
       //     }
       // }
     
       if (projects) {
           projects.style.paddingTop = headerHeight + 'px';
       }

    //    menu.style.top = menuPosition + 'px';
       console.log(menuPosition);
   }

   handleHeaderHeight();

   window.addEventListener('resize', handleHeaderHeight);

}